import {MODAL_TYPE, showModal} from '../../../../forecast-app/shared/components/modals/generic_modal_conductor';
import {AgentFormValues} from '../shared/novaAgentForm';

export interface CreateAgentModalPayload {
	categories: Array<{categoryId: string; name: string}>;
	existingNames: string[];
	onSubmit: (values: AgentFormValues) => Promise<void>;
	onCreateCategory: (name: string) => Promise<{categoryId: string; name: string}>;
}

export const showCreateAgentModal = (props: CreateAgentModalPayload): void => {
	showModal({type: MODAL_TYPE.NOVA_CREATE_AGENT, ...props});
};
